import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import ErrorBoundary from '../../ErrorBoundary';

const AdminCustomFieldEditMainEdit = ({
  customField,
  customFieldId,
  errors,
  saving,
  handleChange,
  handleSave,
  handleDelete,
}) => {
  const intl = useIntl();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div className="custom-field-profile">
          <div className="custom-field-details">
            <FormGroup row>
              <Col sm="6">
                <Label for="inpCustomFieldName">
                  {intl.formatMessage({ defaultMessage: 'Name' })}
                </Label>
                <Input
                  type="text"
                  name="name"
                  id="inpCustomFieldName"
                  placeholder={intl.formatMessage({ defaultMessage: 'Custom Field name' })}
                  value={customField.name || ''}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  invalid={errors.includes('name')}
                  autoFocus={!customFieldId}
                />
                {errors.includes('name') && (
                  <FormFeedback>
                    {intl.formatMessage({ defaultMessage: 'This field is required' })}
                  </FormFeedback>
                )}
              </Col>
              <Col sm="6">
                <Label for="inpCustomFieldType">
                  {intl.formatMessage({ defaultMessage: 'Type' })}
                </Label>
                <Input
                  id="inpCustomFieldType"
                  type="select"
                  className="custom-select"
                  name="type"
                  defaultValue={customField.type}
                  onChange={handleChange}
                >
                  <option value="text">
                    {intl.formatMessage({ defaultMessage: 'One line text' })}
                  </option>
                  <option value="textarea">
                    {intl.formatMessage({ defaultMessage: 'Long text' })}
                  </option>
                  <option value="url">
                    {intl.formatMessage({ defaultMessage: 'Link' })}
                  </option>
                </Input>
                {errors.includes('type') && (
                  <FormFeedback>
                    {intl.formatMessage({ defaultMessage: 'This field is required' })}
                  </FormFeedback>
                )}
              </Col>
            </FormGroup>
            <FormGroup>
              <Label for="inpCustomFieldRequired" className="switch">
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    id="inpCustomFieldRequired"
                    name="required"
                    checked={customField.required}
                    value={true}
                    onChange={handleChange}
                  />
                  <i />
                </div>
                <div className="switch-details">
                  <span>{intl.formatMessage({ defaultMessage: 'Required' })}</span>
                </div>
              </Label>
            </FormGroup>
            <FormGroup>
              <Label for="show_on_shares" className="switch">
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    id="show_on_shares"
                    name="show_on_shares"
                    defaultChecked={customField.show_on_shares}
                    value={true}
                    onChange={handleChange}
                  />
                  <i />
                </div>
                <div className="switch-details">
                  <span>{intl.formatMessage({ defaultMessage: 'Show on share pages' })}</span>
                </div>
              </Label>
            </FormGroup>
          </div>
        </div>
      </div>
      <AdminEditButtons
        handleSave={handleSave}
        saving={saving}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Custom Field' })}
        hideDelete={customFieldId === null}
        handleDelete={handleDelete}
      />
    </ErrorBoundary>
  );
};

AdminCustomFieldEditMainEdit.propTypes = {
  customField: PropTypes.object,
  customFieldId: PropTypes.string,
  errors: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

AdminCustomFieldEditMainEdit.defaultProps = {
  customField: null,
  customFieldId: null,
};

export default AdminCustomFieldEditMainEdit;
